import { render, staticRenderFns } from "./ReferrerChart.vue?vue&type=template&id=4770bd23&scoped=true&lang=pug&"
import script from "./ReferrerChart.vue?vue&type=script&lang=js&"
export * from "./ReferrerChart.vue?vue&type=script&lang=js&"
import style0 from "./ReferrerChart.vue?vue&type=style&index=0&id=4770bd23&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4770bd23",
  null
  
)

/* custom blocks */
import block0 from "./ReferrerChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports